<app-button-advanced
  [action]="resetViewsAction"
  [hotButton]="'V'"
  matTooltip="{{ 'viewer.Tools.ResetViews' | translate }}"
>
</app-button-advanced>
